import { QuestionTypeEnum } from '@/types/schema';

import { QuestionEditorProps, QuizEditField } from '../../../types';
import ImageHotspotEditor from '../../ImageHotspotEditor';

const ImageHotspotEditField: QuizEditField = {
  Editor: (props: QuestionEditorProps) => <ImageHotspotEditor {...props} />,
  type: QuestionTypeEnum.ImageHotspot,
};

export default ImageHotspotEditField;
